<script>
import LazyContent from '../UI/Loading/LazyContent.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import BlockContent from '../UI/Content/BlockContent.vue'
import Role from '../../../../Constants/Role.ts'
import TabMenu from '../UI/TabMenu.vue'
import OutstandingItem from './OutstandingItem.vue'
import { useQueryParameter } from '../../../../Composables/useQueryParameter.ts'

export default {
  components: { OutstandingItem, TabMenu, BlockContent, LazyContent },
  mixins: [mixinComponent],
  props: {
    outstandings: { type: Array, required: true },
    loading: { type: Boolean, required: false, default: false },
    isOutstandingSupplier: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      tab: null,
    }
  },
  watch: {
    currentTabKey(newTab) {
      const availableTabs = this.tabs?.filter(({ show }) => show) ?? []
      const selectedTab = availableTabs.find(({ key }) => key === newTab) ?? null

      return selectedTab ?? availableTabs[0] ?? null
    },
  },
  setup() {
    const { value: currentTabKey } = useQueryParameter('tab')

    return { currentTabKey }
  },
  computed: {
    canSeeRefinancerTab() {
      return this.hasRole(Role.OUTSTANDING_REFINANCER_SHOW)
    },
    tabs() {
      return [
        {
          key: 'company',
          show: this.hasRole(Role.OUTSTANDING_SHOW),
          title: this.$t('contract.information.outstanding.company'),
        },
        {
          key: 'refinancer',
          show: this.canSeeRefinancerTab,
          title: this.$t('contract.information.outstanding.refinancer'),
        },
        {
          key: 'supplier',
          show: this.hasRole(Role.OUTSTANDING_SUPPLIER_SHOW),
          title: this.$t('contract.information.outstanding.supplier'),
        },
      ]
    },
    columns() {
      return [
        { key: 'order', label: this.$t('contract.outstanding.label_order'), show: true },
        { key: 'dueAt', label: this.$t('contract.outstanding.label_due_at'), show: true },
        { key: 'rent', label: this.$t('contract.outstanding.label_rent'), show: true },
        {
          key: 'remainingCapital',
          label: this.$t('contract.outstanding.label_remaining_capital'),
          show: this.tab?.key !== 'supplier',
        },
        { key: 'remainingRent', label: this.$t('contract.outstanding.label_remaining_rent'), show: true },
        { key: 'renewingBalance', label: this.$t('contract.outstanding.label_renewing_balance'), show: true },
        { key: 'nonRenewingBalance', label: this.$t('contract.outstanding.label_nonrenewing_balance'), show: true },
      ]
    },
  },
}
</script>
<template>
  <div>
    <TabMenu v-model="tab" :tabs="tabs" />

    <BlockContent>
      <LazyContent :loading="loading">
        <div class="row d-flex justify-content-center my-3">
          <table class="table table-borderless">
            <thead>
              <tr class="font-weight-bold text-center">
                <th v-for="column in columns" v-show="column.show" :key="column.key" scope="col" class="col-1">
                  {{ column.label }}
                </th>
              </tr>
            </thead>
            <tbody class="text-center">
              <OutstandingItem
                v-for="outstanding in outstandings"
                :key="`outstanding-${outstanding.id}`"
                :outstanding="outstanding"
                :tab-key="tab.key"
              />
            </tbody>
            <tfoot>
              <tr class="font-weight-bold text-center">
                <th v-for="column in columns" v-show="column.show" :key="column.key" scope="col" class="col-1">
                  {{ column.label }}
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
      </LazyContent>
    </BlockContent>
  </div>
</template>
